import { ReactElement } from 'react';
import Services from '~/ui/components/common/Services';
import { productServicesMock } from '~/ui/components/common/Services/servicesMock';
import YMALCarousel from '~/ui/components/common/YMALCarousel';
import { IUpsellProduct } from '~/ui/components/common/Swiper/types';

interface ProductExtraContentProps {
  ymalProducts: IUpsellProduct[];
}

const ProductExtraContent = ({ ymalProducts }: ProductExtraContentProps): ReactElement => (
  <div>
    <Services items={productServicesMock} />
    <div className="product-carousel">
      {!!ymalProducts.length && <YMALCarousel items={ymalProducts} />}
    </div>
  </div>
);

export default ProductExtraContent;
